import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import OSM from 'ol/source/OSM';
import VectorSource from 'ol/source/Vector.js';
import {fromLonLat} from 'ol/proj.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import {Fill, Stroke, Style} from 'ol/style.js';
import Projection from 'ol/proj/Projection.js';

import {regions} from './regions.js';
import {boundary} from './boundary.js';

console.log(regions);

const regionsVectorSource = new VectorSource({
  features: new GeoJSON().readFeatures(regions, {
        dataProjection: 'EPSG:2274',
	featureProjection: 'EPSG:3857'
    })
});

console.log(regionsVectorSource.getFeatures());

const boundaryVectorSource = new VectorSource({
  features: new GeoJSON().readFeatures(boundary),
});

const regionsVectorLayer = new VectorLayer({
  source: regionsVectorSource,
  style: new Style({
    stroke: new Stroke({
      color: 'blue',
      lineDash: null,
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)',
    })
  }),
});

const boundaryVectorLayer = new VectorLayer({
  source: boundaryVectorSource,
  style: new Style({
    stroke: new Stroke({
      color: 'black',
      lineDash: null,
      width: 3,
    }),
    fill: new Fill({
      color: 'rgba(255, 0, 0, 0.01)',
    })
  }),
});

console.log(regionsVectorSource.features);

const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    }),
    regionsVectorLayer,
    boundaryVectorLayer,
  ],
  view: new View({
    center: fromLonLat([-85.688602, 36.711461]),
    zoom: 10
  })
});
